import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SpinnerService {
  visibility: BehaviorSubject<boolean>;

  constructor() {
    this.visibility = new BehaviorSubject(false);
  }

  show() {
    this.visibility.next(true);
    document.body.style.pointerEvents = "none";
  }

  hide() {
    document.body.style.pointerEvents = "auto";
    return this.visibility.next(false);
  }
}
